import { createApp, h } from 'vue'
import { createInertiaApp, Link } from '@inertiajs/vue3'
import i18n from './Plugins/i18n'
import pusher from './Plugins/Pusher'
import ui from '@deliver-up/ui'
import './Plugins'
import { createPinia } from 'pinia'
import resolvePage from 'access/shared/resolvePage'
import '../css/app.css'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import * as Sentry from '@sentry/vue'
// import * as Sentry from "@sentry/browser";

import { AgGridVue } from 'ag-grid-vue3'
import 'ag-grid-enterprise'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-quartz.css'
import { LicenseManager } from 'ag-grid-enterprise'

createInertiaApp({
  progress: { color: 'var(--primary-500)' },
  resolve: resolvePage,
  setup({ el, App, props, plugin }) {
    //window.InertiaProps = props.initialPage.props

    const app = createApp({ render: () => h(App, props) })

    let dsn = props.initialPage.props?.sentry?.dsn
    if (dsn) {
      Sentry.init({
        app,
        dsn: dsn,
        environment: 'production',
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
          Sentry.captureConsoleIntegration(),
          Sentry.captureEvent(),
          Sentry.captureMessage(),
          // Sentry.captureSession(),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        tracePropagationTargets: [
          'localhost',
          /^https:\/\/butagaz\.dumanage\.com/,
          /^https:\/\/testing\.dumanage\.space/,
          /^https:\/\/butagaz\.dumanage\.space/,
        ],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
      })
    }

    const key = props.initialPage.props?.grid?.licence_key
    if (key) {
      LicenseManager.setLicenseKey(key)
    }
    return app
      .component('Link', Link)
      .component('AgGridVue', AgGridVue)
      .use(createPinia())
      .use(plugin)
      .use(ui)
      .use(i18n)
      .use(pusher, {
        appKey: props.initialPage.props.pusher.app_key,
        cluster: props.initialPage.props.pusher.app_cluster,
      })
      .use(VueSweetalert2)
      .mixin({ methods: { route } })
      .mount(el)
  },
})
